import styled from 'styled-components';
import Link from '../../Atoms/Link/Link';
import Text from '../../Atoms/Text/Text';
import hideVisually from '../../../theme/shared/hideVisually';
import zIndex from '../../../theme/shared/zIndex';
var MoreInfo = styled(Text).withConfig({
  displayName: "PartnerLinkstyle__MoreInfo",
  componentId: "sc-1lfodop-0"
})(["", " height:auto;@media ", "{font-size:", ";}"], hideVisually, function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoint('small');
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSize('s');
});
var Item = styled(Link).withConfig({
  displayName: "PartnerLinkstyle__Item",
  componentId: "sc-1lfodop-1"
})(["display:block;position:relative;padding:0;border:none;:hover,:focus{border:none;", "{overflow:inherit;clip-path:none;margin:0;text-align:center;transform:translateY(-50%);clip:auto;top:50%;left:0;width:100%;", ";}::after{content:'';position:absolute;display:block;top:0;right:0;bottom:0;left:0;width:100%;height:100%;background-color:", ";}}"], MoreInfo, zIndex('medium'), function (_ref3) {
  var theme = _ref3.theme;
  return theme.color('red');
});
export { MoreInfo, Item };